/* Forretningsområder: panelet man peker på eller gir tastaturfokus, utvider seg.
 *
 * Panelene er ikke lenker, så de får tabindex og aria-expanded fra templaten.
 * Teksten som er visuelt sammenklappet ligger fortsatt i markeringen, slik at
 * skjermlesere leser alle tre. */

import gsap from 'gsap';
import { $, $$, mindreBevegelse } from '../kjerne/verktoy.js';

export function startOmrader() {
  const rad = $('#omrade-rad');
  if (!rad) return;

  const paneler = $$('.omrade', rad);

  const apne = valgt => {
    for (const p of paneler) {
      const apen = p === valgt;
      p.classList.toggle('apen', apen);
      p.setAttribute('aria-expanded', String(apen));
    }
  };

  for (const panel of paneler) {
    panel.addEventListener('mouseenter', () => apne(panel));
    panel.addEventListener('focusin', () => apne(panel));
    panel.addEventListener('click', () => apne(panel));
    panel.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        apne(panel);
      }
    });
  }

  if (mindreBevegelse.matches) return;

  gsap.from('.omrade', {
    y: 70, opacity: 0, duration: 1.2, ease: 'expo.out', stagger: .1,
    scrollTrigger: { trigger: rad, start: 'top 85%' },
  });
  gsap.from('.omrader-inngang', {
    y: 20, opacity: 0, duration: 1, ease: 'expo.out',
    scrollTrigger: { trigger: '.omrader-inngang', start: 'top 90%' },
  });
}
